// Where the LOAN BIDS button shows (spec §1). HSC_FINANCING comes back from
// the server as '0'/'1' as well as booleans, and '0' is truthy, so it is read
// explicitly rather than by truthiness.
export function hasPeakFinancing(data) {
    const value = data && data.HSC_FINANCING;
    return value === true || value === 1 || value === '1';
}

/** SUMMIT or External deals with Peak Financing ticked: on the In Neg/Under Contract tab. */
export function showOnInNeg(data) {
    return Boolean(data) && ['SUMMIT', 'External'].indexOf(data.SOURCE) !== -1 && hasPeakFinancing(data);
}

/** Peak's own deals: on the Property tab. */
export function showOnPropertyTab(data) {
    return Boolean(data) && data.SOURCE === 'HSC';
}
